import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {PATH_WEB_FORMS} from '../../routing/paths'
import Dashboard from './Dashboard'
import {OverviewForm} from './pages/Overview.form'
import {FormsProvider} from '../../@contexts'
import {PageHeader} from '../../@components/widgets/PageHeader'
import {useAuthorization} from '../../features'
import {BreadcrumbsConst} from '../../@constants'

const WebFormsPage: React.FC = () => {

  const {isAuthorized, redirectTo} = useAuthorization({productKey: 'webForms', redirectPath: PATH_WEB_FORMS.root})
  const webFormsBreadCrumbs = BreadcrumbsConst('Vos formulaires', redirectTo);

  // const infos = {
  //   icon: '/media/icons/duotune/animation/ani001.svg',
  //   description: 'hello world',
  //   svgClassName: 'web-forms',
  // }

  return (
    <FormsProvider>
      <Switch>
        {!isAuthorized && <Redirect to={redirectTo} />}
        {isAuthorized && (
          <>
            <div className="mb-5">
              <PageHeader icon={'/media/icons/duotune/animation/ani001.svg'}
                          title={'Suivi des formulaires soumis'}
                          description={'Accédez ici à un tableau de bord détaillé pour gérer vos formulaires de contact. Visualisez les formulaires reçus, leur statut de traitement, ainsi que le taux de réponse associé. Cet outil vous permet de suivre efficacement les interactions avec vos clients et de garantir une gestion optimale des demandes.'}
              />
            </div>

            <Route path={PATH_WEB_FORMS.root} exact={true}>
              <PageTitle breadcrumbs={webFormsBreadCrumbs}>Tableau de bord</PageTitle>
              <Dashboard />
            </Route>

            <Route path={`${PATH_WEB_FORMS.form}/:id`} exact={true}>
              <PageTitle breadcrumbs={webFormsBreadCrumbs}>Aperçu</PageTitle>
              <OverviewForm />
            </Route>
          </>
        )}
        <Redirect to={redirectTo} />
      </Switch>
    </FormsProvider>
  )
}

export default WebFormsPage
